import { adapi, Debug } from '~';

const debug = Debug('creative');
const SET_CURRENT = 'SET_CURRENT';
const SET_LOADING = 'SET_LOADING';
const SET_CALL_TO_ACTION = 'SET_CALL_TO_ACTION';

const getters = {
  currentCreative(state) {
    return state.current;
  },
};
const actions = {
  getCreative({ commit }, id) {
    commit(SET_LOADING, true);
    return adapi.get(`creatives/${id}`)
      .then(result => {
        debug.info('get', result);
        commit(SET_CURRENT, { current: result, error: null });
        commit(SET_LOADING, false);
      })
      .catch(error => {
        commit(SET_CURRENT, { current: null, error });
        commit(SET_LOADING, false);
      });
  },
  getCallToActionList({ commit }) {
    return adapi.get('creatives/call-to-action')
      .then(result => {
        commit(SET_CALL_TO_ACTION, { list: result, error: null });
      })
      .catch(error => {
        commit(SET_CALL_TO_ACTION, { list: null, error });
      });
  },
  completeCreative({ commit, state }, data) {
    return adapi.post(`creatives/${data.id}/complete`, null, (data.body ? data.body : null))
      .then(result => {
        debug.info('complete', result);
        commit(SET_CURRENT, { current: result, error: null });
      })
      .catch(error => {
        commit(SET_CURRENT, { current: state.current, error });
      });
  },
  reloadCreative({ commit, state }, loading = false) {
    if (loading) commit(SET_LOADING, true);

    return adapi.get(`creatives/${state.current.id}`)
      .then(result => {
        commit(SET_CURRENT, { current: result, error: null });
        if (loading) commit(SET_LOADING, false);
      })
      .catch(() => {
        if (loading) commit(SET_LOADING, false);
      });
  },
  setCurrentCreative({ commit }, creative) {
    commit(SET_CURRENT, { current: creative, error: null });
    commit(SET_LOADING, false);
  },
  // Rabbit actions
  moveForward({ commit, state }, id) {
    return adapi.post(`creatives/${id}/complete`)
      .then(result => {
        commit(SET_CURRENT, { current: result, error: null });
        commit(SET_LOADING, false);
      })
      .catch(error => {
        commit(SET_LOADING, false);
        throw error;
      });
  },
  moveBack({ commit, state }, { id, data }) {
    return adapi.post(`creatives/${id}/reject`, null, data)
      .then(result => {
        commit(SET_CURRENT, { current: result, error: null });
        commit(SET_LOADING, false);
      })
      .catch(error => {
        commit(SET_LOADING, false);
        throw error;
      });
  },
};

const mutations = {
  [SET_CURRENT](state, { current, error }) {
    state.current = current;
    state.error = error;
  },
  [SET_CALL_TO_ACTION](state, { list, error }) {
    state.callToActions = list;
    state.error = error;
  },
  [SET_LOADING](state, loading) {
    state.loading = loading;
  },
};

export default {
  namespaced: true,
  state: {
    current: null,
    error: null,
    callToActions: null,
    loading: false,
  },
  actions,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/creative.js